import styled, { css } from 'styled-components'

type CommonProps = {
  $checked?: boolean
  $disabled?: boolean
}

export const Label = styled.span<CommonProps>`
  ${({ theme }) => theme.textStyles.textLargeStrong};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.neonBlue};
  transition: color 0.3s ease;
  min-width: 7.2rem;

  ${({ $checked, theme }) =>
    $checked &&
    css`
      color: ${theme.colors.pureWhite};
    `};

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
    `}
`

export const Wrapper = styled.label<CommonProps>`
  border: 1px solid ${({ theme }) => theme.colors.neonBlue};
  border-radius: 3rem;
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.3s ease;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  padding: 3rem 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neonBlue};

    ${Label} {
      color: ${({ theme }) => theme.colors.pureWhite};
    }
  }

  ${({ $checked, theme }) =>
    $checked &&
    css`
      background-color: ${theme.colors.neonBlue};
    `};

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}
`

export const Checkbox = styled.input`
  display: none;
`
